import React, { ReactNode } from 'react';

import { Text } from '@shared/components/bootstrap';

import { Panel } from '@admin/components/helpers/panel';
import { usePermission } from '@admin/hooks/use_permission';
import type { PermissionAction, PermissionResource } from '@admin/libraries/access_control_catalog.generated';

type PermissionProps = {
  action: PermissionAction;
  children: ReactNode;
  denied?: ReactNode | null;
  resource: PermissionResource;
};

const defaultDenied = (
  <Panel>
    <Panel.Body>
      <Text tag="p" style="muted">
        You do not have permission to view this page. If you believe this is an error please contact your supervisor.
      </Text>
    </Panel.Body>
  </Panel>
);

export const Permission: React.FC<PermissionProps> = ({ resource, action, children, denied }) => {
  const allowed = usePermission(resource, action);

  if (allowed) {
    return <>{children}</>;
  }

  if (denied === null) {
    return null;
  }

  if (denied !== undefined) {
    return <>{denied}</>;
  }

  return defaultDenied;
};
